"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShortcutProvider;
exports.Provider = exports.Consumer = exports.ShortcutContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../ShortcutManager/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ShortcutContext = /*#__PURE__*/_react["default"].createContext(null);

exports.ShortcutContext = ShortcutContext;
var Consumer = ShortcutContext.Consumer,
    Provider = ShortcutContext.Provider;
exports.Provider = Provider;
exports.Consumer = Consumer;

function ShortcutProvider(_ref) {
  var children = _ref.children;

  var shortcutManager = _react["default"].useRef(new _index["default"]());

  _react["default"].useEffect(function () {
    shortcutManager.current.setup();
  }, []);

  return /*#__PURE__*/_react["default"].createElement(ShortcutContext.Provider, {
    value: shortcutManager.current
  }, children);
}